import api from '@/api/axiosConfig';

export const permisosService = {
  getFuncionalidades: () =>
    api.get('/pos/permisos/funcionalidades').then(r => r.data),

  getPlantillas: () =>
    api.get('/pos/permisos/plantillas').then(r => r.data),

  getPermisosEmpresa: (empresaId: number) =>
    api.get(`/pos/permisos/empresa/${empresaId}`).then(r => r.data),

  guardarPermisos: (empresaId: number, permisos: any[]) =>
    api.put(`/pos/permisos/empresa/${empresaId}`, permisos).then(r => r.data),

  cargarPlantilla: (empresaId: number, rolNombre: string) =>
    api.post(`/pos/permisos/empresa/${empresaId}/cargar-plantilla`,
      JSON.stringify(rolNombre), { headers: { 'Content-Type': 'application/json' }}).then(r => r.data),

  verificarPermiso: (empresaId: number, codigo: string) =>
    api.get('/pos/permisos/verificar', { params: { empresaId, codigo } }).then(r => r.data),

  autorizar: (dto: {
    codigoBarras: string; funcionalidadCodigo: string;
    empresaId: number; aperturaCajaId?: number;
    entidad?: string; entidadId?: string;
  }) => api.post('/pos/permisos/autorizar', dto).then(r => r.data),

  getLog: (empresaId: number, params?: any) =>
    api.get('/pos/permisos/log', { params: { empresaId, ...params } }).then(r => r.data),

  /** Funcionalidades que el usuario actual puede usar en la empresa (según su perfil). */
  misPermisos: (empresaId: number) =>
    api.get('/pos/permisos/mis-permisos', { params: { empresaId } }).then(r => r.data as {
      roles: string[]; rolBase?: string; puedeAutorizar: boolean; funcionalidades: string[];
    }),

  // Carné (código de barras) por usuario de la empresa
  generarCodigo: (usuarioPOSId: number, regenerar = false) =>
    api.post(`/pos/usuarios-pos/${usuarioPOSId}/generar-codigo`, null, { params: { regenerar } }).then(r => r.data),

  getTarjeta: (usuarioPOSId: number) =>
    api.get(`/pos/usuarios-pos/${usuarioPOSId}/tarjeta`).then(r => r.data),
};
